import { render } from "./Wizard.vue?vue&type=template&id=2b424788&scoped=true"
import script from "./Wizard.vue?vue&type=script&lang=js"
export * from "./Wizard.vue?vue&type=script&lang=js"

import "./Wizard.vue?vue&type=style&index=0&id=2b424788&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b424788"]])

export default __exports__